import {FC, useCallback, useMemo, useState} from 'react';
import {Richtext} from '../../../../common/Richtext';
import {TheButton} from '../../../../common/TheButton';
import {useComments} from '../../../../../hooks/services/useComments';
import styles from './Feedback.module.scss';
import { TooltipHost } from '@fluentui/react';

interface IAddFeedbackProps {
  processId: number;
  onCommentAdded: () => void;
}

export const AddFeedback: FC<IAddFeedbackProps> = ({processId, onCommentAdded}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [content, setContent] = useState('');
  const [counter, setCounter] = useState(1);
  const {createComment} = useComments();

  const onAdd = useCallback(() => {
    (async () => {
      setIsLoading(true);
      await createComment(processId, content);
      setContent('');
      setCounter(counter + 1);
      onCommentAdded();
      setIsLoading(false);
    })();
  }, [content, counter, createComment, onCommentAdded, processId]);

  
    const isContentEmpty = useMemo(():boolean => {
    if (!content) return true
  
    const stripped = content
      .replace(/<br\s*\/?>/gi, '') 
      .replace(/&nbsp;/gi, '') 
      .replace(/\s+/g, ' ') 
      .trim();
    const textOnly = stripped.replace(/<[^>]*>/g, '').trim();
    return textOnly === '';
  },[content])

  return (
    <div>
      <Richtext key={counter} onChange={setContent} disable={isLoading} />
      <TooltipHost content={isContentEmpty ? "A comment is required" : ""}>
      <TheButton
        className={styles.button}
        primary
        disabled={isLoading || isContentEmpty}
        iconProps={{iconName: 'Add'}}
        onClick={onAdd}>
        Add comment
      </TheButton>
      </TooltipHost>
    </div>
  );
};
